import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  title: string,
 *  content: string,
 *  isPublished: number,
 *  lastEdited: string,
 *  pemalink: string,
 *  sortOrder: number
 *  }} HelpPages
 */

const api = new Api("api/HelpPages");

/**
 * @returns {Promise<AxiosResponse<HelpPages[]>>}
 */
export const getAll = () => api.get();

export const remove = (permalink) => api.del(permalink);

export const create = (payload) => api.post("", payload);

/**
 * @param {string} permalink
 * @returns {Promise<AxiosResponse<HelpPages>>}
 */
export const getByPermalink = (permalink) => api.get(permalink);

export const update = (permalink, payload) => api.putId(permalink, payload);
